import React from 'react';
import { Youtube } from 'lucide-react';

export default function YouTubeHero() {
  const scrollToGenerator = () => {
    document.getElementById('youtube-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1611162616475-46b635cb6868?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="YouTube content creation setup"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-red-900 via-red-800 to-red-900 opacity-85"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Youtube className="w-16 h-16 text-red-400 animate-pulse" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          YouTube Tag Generator
        </h1>
        <p className="text-xl text-red-100 mb-8 max-w-3xl mx-auto">
          Generate optimized tags for your YouTube videos with our AI-powered tool.
          Boost your video visibility and reach more viewers with perfect tags.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-red-700/50 px-4 py-2 rounded-full text-white text-sm border border-red-500/30">
            SEO Optimized
          </span>
          <span className="bg-red-700/50 px-4 py-2 rounded-full text-white text-sm border border-red-500/30">
            Trending Tags
          </span>
          <span className="bg-red-700/50 px-4 py-2 rounded-full text-white text-sm border border-red-500/30">
            Category Specific
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-red-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-red-600 transition-all cursor-pointer transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center gap-2 mx-auto"
        >
          <Youtube className="w-5 h-5" />
          Generate YouTube Tags
        </button>
        <p className="mt-6 text-sm text-red-200 bg-red-800/30 inline-block px-4 py-2 rounded-full mx-auto">
          Trusted by over 100,000+ content creators worldwide
        </p>
      </div>
    </div>
  );
}